import { render, staticRenderFns } from "./ChatController.vue?vue&type=template&id=92a227d4&scoped=true"
import script from "./ChatController.vue?vue&type=script&lang=js"
export * from "./ChatController.vue?vue&type=script&lang=js"
import style0 from "./ChatController.vue?vue&type=style&index=0&id=92a227d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a227d4",
  null
  
)

export default component.exports